var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.468,
    height: 18.271,
    viewBox: "0 0 18.468 18.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37813",
    "data-name": "Group 37813",
    transform: "translate(-1575.532 288.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3240",
    "data-name": "Rectangle 3240",
    width: 18,
    height: 18,
    transform: "translate(1576 -288.998)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_4213447_arrow_load_loading_refresh_reload_icon",
    "data-name": "4213447_arrow_load_loading_refresh_reload_icon",
    transform: "translate(1576.004 -287.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M29.151,54.053a7.3,7.3,0,0,1-9.281-.1h1.842V52.811H18v3.712h1.143v-1.7A8.346,8.346,0,0,0,23.8,56.765a7.441,7.441,0,0,0,.786.043A8.443,8.443,0,0,0,32.592,45.8l-1.085.343a7.275,7.275,0,0,1-2.356,7.91Z",
    transform: "translate(-16.14 -39.972)",
    fill: "#4c96ce",
    stroke: "#4b96cd",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M18.948,7.07A8.427,8.427,0,0,0,5.341,15.923l1.085-.343A7.287,7.287,0,0,1,18.235,7.969H16.378V9.112h3.712V5.4H18.948Z",
    transform: "translate(-4.952 -4.968)",
    fill: "#4c96ce",
    stroke: "#4b96cd",
    strokeWidth: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.4addf15c6208fb9fcef390b2f24cbd28.svg";
export { ForwardRef as ReactComponent };